import { SC } from "../helper/ServerCall";

export const dataSync = {
    getErrorsListing,
    getErrorMessagesPaginated,
    markSyncErrorFixed,
    getErrorStates,
    getErrorStatesForBrand,
};

function getErrorsListing(page, brand_id, from_date, to_date, filter, sort, pageSize) {
    return SC.getCall(
        `errors-list?page=${page}&brand_id=${brand_id}&from_date=${from_date}&to_date=${to_date}&filter=${filter}&sort=${sort}&pageSize=${pageSize}`
    );
}

function getErrorMessagesPaginated(error_id, page, filter, sort, pageSize) {
    return SC.getCall(
        `errors/${error_id}/messages?page=${page}&filter=${filter}&sort=${sort}&pageSize=${pageSize}`
    );
}


function markSyncErrorFixed(error_ids) {
    return SC.postCall(
        `errors/mark-fixed`, error_ids
    );
}


function getErrorStates() {
    return SC.getCall(
        `errors/get-states`
    );
}

function getErrorStatesForBrand(brand_id) {
    return SC.getCall(
        `errors/get-states?brand_id=${brand_id}`
    );
}



// WEBPACK FOOTER //
// ./src/services/data-sync.js